import { inject, Injectable } from '@angular/core';
import {
  CheckUserCompleteProfileQueryService,
  GetMyProfileQueryService,
  ProfileAnswerInput,
  SubmitProfileStepMutationService,
} from '@shared/graphql/generated/api.generated';

@Injectable()
export class ProfileService {
  private readonly getMyProfileQueryService = inject(GetMyProfileQueryService);
  private readonly submitProfileStepMutationService = inject(SubmitProfileStepMutationService);
  private readonly checkUserCompleteProfileQueryService = inject(
    CheckUserCompleteProfileQueryService,
  );

  public getUserProfile() {
    return this.getMyProfileQueryService.fetch();
  }

  public submitProfileStep(stepId: string | number, answers: ProfileAnswerInput[]) {
    return this.submitProfileStepMutationService.mutate({
      input: {
        step_id: stepId,
        answers,
      },
    });
  }

  public checkUserCompleteProfile() {
    return this.checkUserCompleteProfileQueryService.fetch();
  }
}
